module.exports = __webpack_public_path__ + "img/live-stream.cc2ac515.png";